import {lazy} from 'react';

export const HelpCenterEsLazy = lazy(() => import(/* webpackChunkName: "helpCenterEs" */ '.'));
